import axiosInstance from "@/api/axios-instance";
import { Region } from "../types/region";

export async function getRegions({
  page = 0,
  search,
}: {
  page?: number;
  search?: string;
}) {
  const params: Record<string, unknown> = { page };
  if (search) params.search = search;

  const response = await axiosInstance.get("/region", { params });
  if (!response.status.toString().startsWith("2")) {
    throw new Error("regions are not loaded");
  }

  const {
    regions,
    nextPage,
    lastPage,
    page: currentPage,
    total,
  } = response.data;

  return {
    regions: regions as Region[],
    nextPage,
    lastPage,
    currentPage,
    total,
  };
}
